<ion-header class="ion-no-shadow ion-no-border">
    <header-notifications *ngIf="!isPreview"></header-notifications>
    <ion-toolbar class="ion-hide-xl-up">
        <!-- <a (click)="routerExtService.back()"
           class="back-link">
            <svg-icon [applyClass]="true"
                      src="/assets/icons/ico-arrow.svg"></svg-icon>

        </a> -->
        <a *ngIf="plt.eventsCount > 1"
           (click)="plt.openEventMenu()"
           class="change-event">
            <svg-icon [applyClass]="true"
                      src="/assets/icons/change-event.svg"></svg-icon>
            <ion-badge *ngIf="plt.unreadOtherCount"
                       class="notification">
                {{ plt.unreadOtherCount }}
            </ion-badge>
        </a>
        <ion-title>{{ 'PROFILE_EDIT_TITLE' | trns }}</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content>

    <ion-refresher (ionRefresh)="refresh($event)"
                   slot="fixed">
        <ion-refresher-content></ion-refresher-content>
    </ion-refresher>

    <app-out-link></app-out-link>

    <profile-edit #profileEdit></profile-edit>

</ion-content>